/**
 * Exhaustiveness guard for `switch` statements over a union type (e.g. a string enum).
 *
 * Place a call to this function immediately after a `switch` whose cases cover every
 * member of the union — do NOT add a `default:` clause to the switch itself, since that
 * would silently swallow a case that is later added to the union. With no `default:`,
 * `value` narrows to `never` here as long as every current member is handled by its own
 * `case`. If a future member is added to the union without a matching `case`, `value`
 * no longer narrows to `never` and the call site fails to compile — turning a silent
 * runtime fallthrough into a build-time error.
 *
 * @param value - The value that should have been narrowed to `never` by exhaustive cases.
 * @throws {Error} Always throws — reaching this at runtime means a case was missed.
 */
export function assertNever(value: never): never {
    throw new Error(`Unhandled case: ${JSON.stringify(value)}`);
}
